export const list_products_watch_for_men = [
    {
        id: 1,
        nameProduct: 'CASIO PROTREK 50.8 mm Nam PRT-B50T-7DR',
        note: 'Chỉ bán online',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/284065/casio-protrek-prt-b50t-7dr-nam-1-600x600.jpg',
        priceold: '9.945.000đ',
        pricenew: '8.453.000đ',
        discount: '15%'
        

    },
    {
        id: 1,
        nameProduct: 'CASIO PROTREK 50.8 mm Nam PRT-B50T-7DR',
        note: 'Chỉ bán online',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/284065/casio-protrek-prt-b50t-7dr-nam-1-600x600.jpg',
        priceold: '9.945.000đ',
        pricenew: '8.453.000đ',
        discount: '15%'

    },
    {
        id: 1,
        nameProduct: 'CASIO PROTREK 50.8 mm Nam PRT-B50T-7DR',
        note: 'Chỉ bán online',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/284065/casio-protrek-prt-b50t-7dr-nam-1-600x600.jpg',
        priceold: '9.945.000đ',
        pricenew: '8.453.000đ',
        discount: '15%'

    },
    {
        id: 1,
        nameProduct: 'CASIO PROTREK 50.8 mm Nam PRT-B50T-7DR',
        note: 'Chỉ bán online',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/284065/casio-protrek-prt-b50t-7dr-nam-1-600x600.jpg',
        priceold: '9.945.000đ',
        pricenew: '8.453.000đ',
        discount: '15%'

    } ,{
        id: 1,
        nameProduct: 'CASIO PROTREK 50.8 mm Nam PRT-B50T-7DR',
        note: 'Chỉ bán online',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/284065/casio-protrek-prt-b50t-7dr-nam-1-600x600.jpg',
        priceold: '9.945.000đ',
        pricenew: '8.453.000đ',
        discount: '15%'

    } ,
    {
        id: 1,
        nameProduct: 'CASIO PROTREK 50.8 mm Nam PRT-B50T-7DR',
        note: 'Chỉ bán online',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/284065/casio-protrek-prt-b50t-7dr-nam-1-600x600.jpg',
        priceold: '9.945.000đ',
        pricenew: '8.453.000đ',
        discount: '15%'

    } 

]

export const list_inform_watch_for_men =['Loại máy: Pin (Quartz)', 'Độ mỏng mặt: 15.8 mm','Chất liệu mặt kính: Kính khoáng Mineral']

export const list_product_flash_sale =[
    {
        id: 1,
        nameProduct: 'KORLEX 30 mm Nữ KL007-02',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/215752/korlex-kl007-02-nu-1-600x600.jpg',
        note: 'Online giá rẻ',
        priceold: '2.600.000đ',
        discount: '-75%',
        pricenew: '650.000đ',
        star: 5
    },
    {
        id: 1,
        nameProduct: 'KORLEX 30 mm Nữ KL007-02',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/215752/korlex-kl007-02-nu-1-600x600.jpg',
        note: 'Online giá rẻ',
        priceold: '2.600.000đ',
        discount: '-75%',
        pricenew: '650.000đ',
        star: 5
    },
    {
        id: 1,
        nameProduct: 'KORLEX 30 mm Nữ KL007-02',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/215752/korlex-kl007-02-nu-1-600x600.jpg',
        note: 'Online giá rẻ',
        priceold: '2.600.000đ',
        discount: '-75%',
        pricenew: '650.000đ',
        star: 5
    },
    {
        id: 1,
        nameProduct: 'KORLEX 30 mm Nữ KL007-02',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/215752/korlex-kl007-02-nu-1-600x600.jpg',
        note: 'Online giá rẻ',
        priceold: '2.600.000đ',
        discount: '-75%',
        pricenew: '650.000đ',
        star: 5
    },
    {
        id: 1,
        nameProduct: 'KORLEX 30 mm Nữ KL007-02',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/215752/korlex-kl007-02-nu-1-600x600.jpg',
        note: 'Online giá rẻ',
        priceold: '2.600.000đ',
        discount: '-75%',
        pricenew: '650.000đ',
        star: 5
    },
    {
        id: 1,
        nameProduct: 'KORLEX 30 mm Nữ KL007-02',
        url: 'https://cdn.tgdd.vn/Products/Images/7264/215752/korlex-kl007-02-nu-1-600x600.jpg',
        note: 'Online giá rẻ',
        priceold: '2.600.000đ',
        discount: '-75%',
        pricenew: '650.000đ',
        star: 5
    }
]

export const list_banner_menu_top = [
    {
        id: 1,
        url:'https://cdn.tgdd.vn/2022/07/campaign/tagline-desktop-4-1200x85.png',
     
    },
    {
        id: 2,
        url: 'https://cdn.tgdd.vn/2022/07/campaign/tagline-desktop-2-1200x85.png',
    
    },
    {
        id: 3,
        url: 'https://cdn.tgdd.vn/2022/07/campaign/tagline-desktop-1-1200x85.png',

    },
    {
        id: 4,
        url: 'https://cdn.tgdd.vn/2022/07/campaign/tagline-desktop-1200x85.png',

    },
    {
        id: 5,
        url: 'https://cdn.tgdd.vn/2022/07/campaign/tagline-desktop-3-1200x85.png'
        
    }
    
]

export const list_option_menu_top = [
    'Nổi bật','% giảm nhiều', 'Giá thấp đến cao','Đồng hồ nam', 'Đồng hồ nữ'
]

export const list_item_sale_casio = [
    {
        id: 1,
        urlImg : 'https://cdn.tgdd.vn/Products/Images/7264/199727/sheen-casio-she-3059sg-7audr-bac-7-600x600.jpg',
        title: 'SHEEN CASIO 34.2 mm Nữ SHE-3059SG-7AUDR',
        initialPrice: '200.000',
        discount: '60',
        online: 'Chỉ bán online'

    },
    {
        id: 2,
        urlImg : 'https://cdn.tgdd.vn/Products/Images/7264/199727/sheen-casio-she-3059sg-7audr-bac-7-600x600.jpg',
        title: 'SHEEN CASIO 34.2 mm Nữ SHE-3059SG-7AUDR',
        initialPrice: '200.000',
        discount: '60',
        online: 'Chỉ bán online'

    }
]

export const list_product_watch_casio= [
    {
        id:1,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        online:'Online giá rẻ',
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:2,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        online:'Online giá rẻ',
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:3,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:1,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:4,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:5,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:4,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:6,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:7,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:8,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:2,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:9,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:10,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:11,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:12,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:13,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:14,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:15,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:16,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:17,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:18,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:19,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:20,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:21,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:22,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:23,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:3,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:24,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:25,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:26,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:27,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:28,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:29,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:30,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:31,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:32,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:33,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:34,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:35,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
    {
        id:36,
        title:'Samsung Galaxy Watch 4 40mm dây silicone',
        initialPrice: '6.490.000',
        discount: 38,
        rate:5,
        rateTotal:57,
        urlImg: 'https://cdn.tgdd.vn/Products/Images/7077/278304/samsung-galaxy-watch-4-40mm-den-600x600.jpg',
    },
]